import { useEffect } from 'react';
import { Outlet } from 'react-router';
import { FormattedMessage } from 'react-intl';
import { toAbsoluteUrl } from '../../../_metronic/helpers';
import { LanguagesLogin } from './LanguagesLogin';

const AuthLayout = () => {
  useEffect(() => {
    const root = document.getElementById('root');
    if (root) root.style.height = '100%';
    return () => { if (root) root.style.height = 'auto'; };
  }, []);

  return (
    <div className='auth-shell'>
      <aside className='auth-brand-panel' aria-label='TC.gate'>
        <div className='auth-brand-mark'>
          <img src={toAbsoluteUrl('media/logos/sps-logo.svg')} alt='SPS' width='52' height='52' />
          <span>TC.gate</span>
        </div>
        <div className='auth-brand-copy'>
          <span className='auth-kicker'><FormattedMessage id='AUTH.LAYOUT.KICKER' /></span>
          <h1>
            <FormattedMessage id='AUTH.LAYOUT.HEADING.LINE1' />
            <br />
            <FormattedMessage id='AUTH.LAYOUT.HEADING.LINE2' />
            <br />
            <em><FormattedMessage id='AUTH.LAYOUT.HEADING.LINE3' /></em>
          </h1>
          <p><FormattedMessage id='AUTH.LAYOUT.DESCRIPTION' /></p>
        </div>
        <div className='auth-trust-row' aria-label='Security features'>          
        </div>
      </aside>

      <main className='auth-main'>
        <section className='auth-card'>
          <div className='auth-form-content'><Outlet /></div>
          <footer className='auth-footer'>
            <LanguagesLogin />
            {/* <nav aria-label='Legal'>
              <a href='' target='_blank' rel='noopener noreferrer'>
                <FormattedMessage id='AUTH.GENERAL.IMPRINT' />
              </a>
              <a href='' target='_blank' rel='noopener noreferrer'>
                <FormattedMessage id='AUTH.GENERAL.PRIVACY' />
              </a>
            </nav> */}
          </footer>
        </section>
      </main>
    </div>
  );
};

export { AuthLayout };
